import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;

    @media (max-width: 1000px) {
        min-width: 0;
    }

    @media (max-width: 800px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 10px;
    }
`;

export const GrupoEsquerdo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .voltar-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        cursor: pointer;

        @media (max-width: 800px) {
            display: none;
        }
    }

    .divider {
        width: 1px;
        height: 16px;
        margin: 0 20px;
        border-left: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

        @media (max-width: 800px) {
            display: none;
        }
    }

    h1 {
        font-size: 32px;
        font-weight: 400;
        margin-right: 40px
    }

    .timer {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        font-size: 14px;
        min-width: 200px;

        > svg {
            width: 16px;
            height: 16px;
        }
    }
`;

export const GrupoDireito = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-shrink: 0;

    @media (max-width: 1000px) {
        flex-shrink: 0;
    }
`;

export const DropDownMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.interfacePure0};
    transition: all .2s;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    &:hover {
        background: ${({ theme }) => theme.colors.interfacePure100};
    }

    .hidden-menu {
        display: flex;
        flex-direction: column;
        min-width: 160px;
        width: fit-content;
        height: fit-content;
        border-radius: 8px;
        padding: 8px 0;
        background: ${({ theme }) => theme.colors.interfacePure0};
        cursor: default;
        position: absolute;
        top: 48px;
        right: 0;
        z-index: 99;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
        &.no-show {
            display: none;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            width: 100%;
            padding: 10px 16px;
            font-size: 14px;
            color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
            cursor: pointer;
            transition: background-color 0.2s ease;
            outline: none;
            border: none;
            background: transparent;
            &:hover,
            &:focus {
                background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
            }
            svg {
                width: 16px !important;
                height: 16px !important;
                min-width: 16px;
                min-height: 16px;
                flex-shrink: 0;
                path {
                    fill: ${({ theme }) => theme.colors.primaryRed400};
                }
            }
        }
    }
`;